import Api from '../api/Api';

class UsuarioApi extends Api {

  async recuperarUsuarioAplicacao (codUsuario) {
    try {
      const { data } = await this.fetch(`/user/${codUsuario}`);
      return data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default UsuarioApi;
